import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

/**
 * Fullscreen button for the dedicated live player screen. Uses the browser Fullscreen API
 * so the entire page (not only the video.js player) goes fullscreen.
 * Listens to fullscreenchange so the icon stays in sync when user exits via Escape.
 */
export function LivePlayerScreenFullscreenControl({
  size = 'small',
}: {
  size?: 'small' | 'medium';
}) {
  const [isFullscreen, setIsFullscreen] = useState(() => Boolean(document.fullscreenElement));

  useEffect(() => {
    function onFullscreenChange() {
      setIsFullscreen(Boolean(document.fullscreenElement));
    }
    document.addEventListener('fullscreenchange', onFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
  }, []);

  const handleToggle = useCallback(async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      } else {
        await document.documentElement.requestFullscreen();
      }
    } catch {
      // Fullscreen may fail (e.g. not triggered by user gesture in some browsers)
    }
  }, []);

  return (
    <Tooltip title={isFullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'}>
      <IconButton size={size} onClick={handleToggle}>
        {isFullscreen ? (
          <FullscreenExitIcon fontSize={size === 'small' ? 'small' : undefined} />
        ) : (
          <FullscreenIcon fontSize={size === 'small' ? 'small' : undefined} />
        )}
      </IconButton>
    </Tooltip>
  );
}
